import { parseEther } from '@ethersproject/units'

export const ONE_ETH = parseEther('1')
